import { useMemo } from 'react';

import { useCayPhongBan } from '../../../co-cau-to-chuc/hooks/usePhongBan';

/**
 * Bảng `id → tên` của danh bạ phòng ban của tenant (`GET /api/v1/departments`, ADR-0067 — `TENANT_USER` đọc được).
 *
 * Native đọc `/api/directory/organizations`; ở platform `actor_don_vi_id` là `department_id` (ADR-0095 mục 4), nên dùng
 * chung cache cây phòng ban với màn Cơ cấu tổ chức (`useCayPhongBan`). Danh bạ hỏng hay đang tải thì bảng rỗng và nơi
 * dùng rơi về tên chụp hoặc mã rút gọn (`nhanDonVi`) — một ô nhãn không được kéo đổ cả màn.
 */
export function useTenDonVi(): ReadonlyMap<string, string> {
  const { data } = useCayPhongBan();
  return useMemo(() => new Map((data ?? []).map((pb) => [pb.id, pb.name])), [data]);
}
